/** Maps ?aiFilter= query values to SalesList pstatus presets or client-side modes. */
export const AI_FILTER_STATUS_MAP = {
  hot: ['Hot'],
  warm: ['Warm'],
  cold: ['Cold'],
  nurture: ['Nurture']
};

/** Client-side only — filtered via AI summary row flags, not pstatus API param. */
export const AI_FILTER_CLIENT_MODES = new Set(['approval', 'uc', 'overdue']);

export function resolveAiFilterStatus(aiFilter) {
  if (!aiFilter) return null;
  const key = String(aiFilter).trim().toLowerCase();
  return AI_FILTER_STATUS_MAP[key] ?? null;
}

export function isClientAiFilter(aiFilter) {
  if (!aiFilter) return false;
  return AI_FILTER_CLIENT_MODES.has(String(aiFilter).trim().toLowerCase());
}

/**
 * Deep-link into the sales leads list with optional project + AI filter.
 */
export function buildAiLeadsListPath({ aiFilter, projectId } = {}) {
  const params = new URLSearchParams();
  if (aiFilter) params.set('aiFilter', String(aiFilter).toLowerCase());
  if (projectId != null && String(projectId).trim() !== '') {
    params.set('project_id', String(projectId));
  }
  const qs = params.toString();
  return `/builder/sales/total-leads${qs ? `?${qs}` : ''}`;
}

export function buildAiLeadDetailPath(leadId) {
  if (leadId == null || leadId === '') return null;
  return `/builder/sales/${leadId}`;
}

export function matchesClientAiFilter(row, aiFilter) {
  if (!aiFilter) return true;
  if (!row) return false;
  const key = String(aiFilter).trim().toLowerCase();
  if (key === 'approval') return !!row.pendingApproval;
  if (key === 'uc') return !!row.ucPending;
  if (key === 'overdue') return !!row.followUpOverdue;
  return true;
}

/** Lead ids from AI summary rows that match a client-side filter mode. */
export function collectClientFilterLeadIds(rows, aiFilter) {
  if (!isClientAiFilter(aiFilter) || !Array.isArray(rows)) return new Set();
  const ids = new Set();
  rows.forEach((row) => {
    if (matchesClientAiFilter(row, aiFilter)) {
      ids.add(Number(row.leadId));
    }
  });
  return ids;
}
